<script setup lang="ts">
defineProps<{ items: readonly { key: string; label: string; colour: string }[] }>()
</script>

<template>
  <ul
    class="flex flex-wrap items-center gap-[var(--space-group)] text-[length:var(--text-step-2)] text-[color:var(--color-text-muted)]"
  >
    <li v-for="item in items" :key="item.key" class="inline-flex items-center gap-[var(--space-inline)]">
      <span aria-hidden="true" class="h-2.5 w-2.5 rounded-[2px]" :style="{ background: item.colour }" />
      {{ item.label }}
    </li>
  </ul>
</template>
